import * as Yup from 'yup';
import { EmailRegex, IDNumberRegex, StandardTextRegex } from './helper';
import { TextConstants } from './Constants';

export const addrressValidationSchema = Yup.object().shape({
  addrLineOne: Yup.string()
    .max(TextConstants.ADDRESS_LINE_MAX, `profile.validationMsg.string.max`)
    .matches(StandardTextRegex, 'profile.validationMsg.addrLineOne.format')
    .required('profile.validationMsg.address.required'),
  addrLineTwo: Yup.string()
    .max(TextConstants.ADDRESS_LINE_MAX, `profile.validationMsg.string.max`)
    .matches(StandardTextRegex, 'profile.validationMsg.addrLineTwo.format'),
  postalCode: Yup.string()
    .max(TextConstants.POSTCODE_MAX, 'profile.validationMsg.postalCode.format')
    .min(TextConstants.POSTCODE_MIN, 'profile.validationMsg.postalCode.format')
    .matches(StandardTextRegex, 'profile.validationMsg.postalCode.format')
    .required('profile.validationMsg.postalCode.required'),

  city: Yup.string()
    .matches(StandardTextRegex, 'profile.validationMsg.city.format')
    .required('profile.validationMsg.city.required'),
  state: Yup.string()
    .matches(StandardTextRegex, 'profile.validationMsg.state.format')
    .required('profile.validationMsg.state.required'),
});

export const shippingAddrressValidationSchema = Yup.object().shape({
  ...addrressValidationSchema.fields,
  contactNickname: Yup.string()
    .matches(StandardTextRegex, 'profile.validationMsg.addressNickname.format')
    .max(TextConstants.CONTACT_NICKNAME_MAX, `profile.validationMsg.string.max`),
  recipientFirstName: Yup.string()
    .matches(StandardTextRegex, 'profile.validationMsg.firstName.format')
    .min(TextConstants.NAME_MIN, 'profile.validationMsg.firstName.format')
    .max(TextConstants.NAME_MAX, `profile.validationMsg.string.max`)
    .required('profile.validationMsg.recipientFirstName.required'),
  recipientLastName: Yup.string()
    .matches(StandardTextRegex, 'profile.validationMsg.lastName.format')
    .min(TextConstants.NAME_MIN, 'profile.validationMsg.lastName.format')
    .max(TextConstants.NAME_MAX, `profile.validationMsg.string.max`),
  phone: Yup.number().required('profile.validationMsg.phone.required'),
});

// Split into smaller schema
const firstNameValidationSchema = Yup.object().shape({
  firstName: Yup.string()
    .matches(StandardTextRegex, 'profile.validationMsg.firstName.format')
    .min(TextConstants.NAME_MIN, 'profile.validationMsg.firstName.format')
    .max(TextConstants.NAME_MAX, `profile.validationMsg.string.max`)
    .required('profile.validationMsg.firstName.required'),
});
const lastNameValidationSchema = Yup.object().shape({
  lastName: Yup.string()
    .matches(StandardTextRegex, 'profile.validationMsg.lastName.format')
    .min(TextConstants.NAME_MIN, 'profile.validationMsg.lastName.format')
    .max(TextConstants.NAME_MAX, `profile.validationMsg.string.max`),
});

// General name validation: firstName required, lastName optional
const nameValidationSchema = Yup.object().shape({
  ...firstNameValidationSchema.fields,
  ...lastNameValidationSchema.fields,
});

export const contactFormValidationSchema = Yup.object().shape({
  ...nameValidationSchema.fields,
  email: Yup.string()
    .matches(EmailRegex, 'profile.validationMsg.email.format')
    .required('profile.validationMsg.email.required'),
});

export const signupFormValidationSchema = Yup.object().shape({
  ...nameValidationSchema.fields,
});

export const InitialRegistrationInputFormValidationSchema = Yup.object().shape({
  ...nameValidationSchema.fields,
  idNumber: Yup.string()
    .matches(IDNumberRegex, 'profile.validationMsg.IDNumber.format')
    .max(TextConstants.ID_NUMBER_MAX, `profile.validationMsg.string.max`)
    .min(TextConstants.ID_NUMBER_MIN, 'profile.validationMsg.IDNumber.format'),
});

export const RegistrationPersonalDetailsValidationSchema = Yup.object().shape({
  ...nameValidationSchema.fields,
  birthDate: Yup.string().required(''),

  password: Yup.string().required(''),
});
